<script setup>
const appStore = useAppStore();

const pendingLoads = computed(() => appStore.waitingFor);

const hasBlockingLoad = computed(() =>
  pendingLoads.value.some((item) => item.blocking)
);

const isLoading = computed(() => pendingLoads.value.length > 0);

const overlayOpacity = computed(() => (hasBlockingLoad.value ? 1 : 0.6));
</script>

<template>
  <section id="loading">
    <v-overlay
      v-model="isLoading"
      class="tw-justify-center tw-items-center !tw-z-[2020]"
      scrim="black"
      :opacity="overlayOpacity"
    >
      <span class="loader"></span>
    </v-overlay>
  </section>
</template>

<style lang="scss" scoped>
.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 3px solid;
  border-color: #fff #fff transparent transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after,
.loader::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: 3px solid;
  border-color: transparent transparent #ff3d00 #ff3d00;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-sizing: border-box;
  animation: rotationBack 0.5s linear infinite;
  transform-origin: center center;
}
.loader::before {
  width: 32px;
  height: 32px;
  border-color: #fff #fff transparent transparent;
  animation: rotation 1.5s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
